module.exports = __webpack_public_path__ + "img/icon4.1a723bf6.png";